import * as React from "react";
import { CustomerNotification, CustomerNotificationLocation } from "@shared-ui/customer-notifications";
import { AnalyticsStore, PageStore } from "bernie-core";
import { inject } from "mobx-react";
import { Experiment, ExperimentControl, ExperimentVariant } from "@shared-ui/experiment-context";

interface CustomerNotificationsProps {
  analytics?: AnalyticsStore;
  location: CustomerNotificationLocation;
  page?: PageStore;
  className?: string;
}

export const CustomerNotifications: React.FC<CustomerNotificationsProps> = inject(
  "analytics",
  "page"
)((props: CustomerNotificationsProps) => {
  const { analytics, location, page, className = "all-b-margin-three" } = props;

  if (!page || !page.pageId) {
    return null;
  }

  /* istanbul ignore next */
  const analyticsCallback = (rfrr: string, linkName: string | null) => {
    analytics?.trackEvent(rfrr, linkName || "RFRR Action Event", analytics.omnitureData, null, true);
  };

  return (
    <React.Fragment>
      <Experiment name={"SURFACE_Travel_Advisory_V2"}>
        <ExperimentControl />
        <ExperimentVariant bucket={1}>
          <div className={className}>
            <CustomerNotification
              inputs={{
                xPageId: page.pageId,
                notificationLocation: location,
              }}
              analyticsCallback={analyticsCallback}
            />
          </div>
        </ExperimentVariant>
      </Experiment>
    </React.Fragment>
  );
});
